<template>
  <el-menu mode="horizontal" :ellipsis="false" class="redesign">
    <el-menu-item index="1">
      <router-link to="/transactions">
        <el-icon><font-awesome-icon size="2xs" icon="dollar-sign" /></el-icon>
        {{ userBalance }}
      </router-link>
    </el-menu-item>
    <el-menu-item index="2">
      <a
        target="_blank"
        href="https://support.traforama.com/"
        class="secondary"
      >
        <el-icon
          ><font-awesome-icon size="sm" icon="question-circle"
        /></el-icon>
        Help
      </a>
    </el-menu-item>
    <el-sub-menu index="3" popper-class="redesign user-nav-popup">
      <template #title>
        <span class="user-name">
          <el-avatar :size="32">
            {{ initials }}
          </el-avatar>
          <span v-if="isDesktop">{{ name }}</span>
        </span>
      </template>
      <el-menu-item v-if="isStaff" index="3-2">
        <GetBackButton />
      </el-menu-item>
      <el-menu-item index="3-3">
        <router-link to="/profile">
          <el-icon><font-awesome-icon color="#0080FF" icon="user" /></el-icon>
          My profile
        </router-link>
      </el-menu-item>
      <el-menu-item index="3-3">
        <router-link to="/notifications">
          <el-icon><font-awesome-icon color="#0080FF" icon="bell" /></el-icon>
          Notifications
        </router-link>
      </el-menu-item>
      <el-menu-item index="3-4">
        <a href="#" @click.prevent="logOut">
          <el-icon
            ><font-awesome-icon color="#0080FF" icon="sign-out"
          /></el-icon>
          Log Out
        </a>
      </el-menu-item>
    </el-sub-menu>
  </el-menu>
</template>
<script lang="ts">
import { defineComponent, computed } from 'vue'
import { useAppStore } from '@/store/modules/app'
import { useUserStore } from '@/store/modules/user'
import GetBackButton from '@/components/GetBackButton.vue'
import useResize from '@/hooks/useResize'
import useRouter from '@/hooks/useRouter'

export default defineComponent({
  name: 'RightMenu',
  components: {
    GetBackButton
  },
  setup() {
    const appStore = useAppStore()
    const userStore = useUserStore()
    const { router } = useRouter()
    const { isDesktop } = useResize()
    const { isRtbUser, isStaff, userID } = userStore

    const name = computed(() => {
      return userStore.staff ? `${userID}: ${userStore.name}` : userStore.name
    })

    const logOut = async function () {
      await userStore.LogOut()
      router.push('/login')
    }

    const userBalance = computed(() => {
      return (userStore.balance / 100).toFixed(2)
    })

    const initials = computed(() => {
      const name = userStore.name?.trim()
      if (!name) return '?'

      return name
        .split(/\s+/)
        .map((part) => part[0])
        .slice(0, 2)
        .join('')
        .toUpperCase()
    })

    return {
      name,
      isStaff,
      isDesktop,
      isRtbUser,
      logOut,
      initials,
      userBalance
    }
  }
})
</script>
<style lang="scss" scoped>
.el-menu {
  border: none;
  gap: 1rem;
  align-items: center;
  height: auto;
  font-weight: 500;
}
.el-menu-item,
:deep(.el-sub-menu__title) {
  line-height: normal;
  height: auto;
  padding: 0;
  border: none !important;
  border-radius: 6px;
  &:not(.is-disabled):hover {
    background-color: rgb(var(--redesign-bg-muted));
  }
  &.is-active {
    color: inherit !important;
  }
  > a,
  .user-name {
    display: flex;
    align-items: center;
    &:hover {
      color: rgb(var(--redesign-text-default));
    }
    &.secondary {
      color: rgb(var(--redesign-text-secondary));
    }
    .el-icon {
      width: 1rem;
      height: 1rem;
      border-radius: 50%;
    }
  }
}
a:not(.secondary) .el-icon,
.el-avatar {
  background-color: rgb(var(--redesign-primary));
  color: #fff;
}
:deep(.el-sub-menu__icon-arrow) {
  position: static;
  margin: 0;
  margin-left: 0.5rem;
}

.el-menu-item > a,
:deep(.el-sub-menu__title) {
  border: none !important;
  padding: 6px 12px !important;
}
.el-avatar {
  margin-right: 0.5rem;
}
</style>
